import React from "react";
import { useField } from "formik";
import { Textarea } from "@jsq/ds/core";

export type AdditionalInstructionsInputProps = {
  fieldName: string;
  maxLength: number;
};

export const AdditionalInstructionsInput: React.FC<AdditionalInstructionsInputProps> = ({
  fieldName,
  maxLength,
}) => {
  const [field, meta] = useField(fieldName);
  const currentLength = (field.value as string)?.length ?? 0;

  return (
    <Textarea
      {...field}
      label="Additional instructions"
      isFullWidth
      size="small"
      maxLength={maxLength}
      helpText={currentLength === 0 ? "Optional" : `${maxLength - currentLength} remaining`}
      errorMessage={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
